module.exports = __webpack_public_path__ + "img/chat.b38ae985.svg";